function init() {
    if ($("#pegelStamm").length > 0) {
        initStammDaten();
    }
}

window.SDstationChange = (item) => {
    var btn = item[0].parentElement.querySelector('i.edit-stammdaten');
    btn.dataset.id = item.find('option:selected').data('id');
}

window.initStammDaten = () => {
    /* Stammdaten */
    var dlg_stamm = $("#pegelStamm").dialog({
        autoOpen: false,
        modal: true,
        width: 540,
        title: "Stammdaten",
        height: 540,
        maxHeight: 540
    });
    $("#stamm-acv").selectmenu();

    $('#stamm-acv-button').css({
        width: '100%'
    });
    $('.edit-stammdaten').off('click');
    $('.edit-stammdaten i').click(function(event) {
        edit_stammdaten(this, event);
    });

    function edit_stammdaten(el, event) {
        var url = '/Handler/HvD/Pegel';

        if ($(el).attr('data-url')) {
            url = $(el).attr('data-url');
        }
        dlg_stamm.extra = $(el).attr('data-type');
        if (!dlg_stamm.extra) {
            // Aus der Liste heraus geöffnet
            dlg_stamm.extra = $(el).children().attr('data-table');
        }
        if (!dlg_stamm.extra) {
            // Aus der HvD-Liste heraus geöffnet
            dlg_stamm.extra = $(el).attr('data-table');
        }

        dlg_stamm.pegelName = $(el).attr('data-id'); //$(el).parent().find('.data-id').val();
        $('.stamm-inner').html('');
        $(el).show();
        $.ajax({
            cache: false,
            type: "POST",
            url: url,
            data: {
                data: {
                    pegel: dlg_stamm.pegelName,
                    extra: dlg_stamm.extra
                }
            }
        }).done(function(data) {
            data = JSON.parse(data);
            $('#warn1').val('');
            $('#warn2').val('');
            var $template = $(dlg_stamm).find('.stamm-item');
            if ($template) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].name === "Warnstufe 1") {
                        $('#warn1').val(data[i].value);
                    } else if (data[i].name === "Warnstufe 2") {
                        $('#warn2').val(data[i].value);
                    } else if (data[i].name === "ACV") {
                        $('#stamm-acv').val(data[i].value).selectmenu('refresh');
                    } else {
                        var cl = $($template).clone();
                        cl.show();
                        var f = cl.find('.labelData')[0];
                        f.name = 'label-' + i;
                        f.value = data[i].name;
                        f = cl.find('.valueData')[0];
                        f.name = 'value-' + i;
                        f.value = data[i].value;
                        $('.stamm-inner').append(cl);
                    }
                }

                /**
                 * Handler entfernen
                 */
                $(dlg_stamm).find('.add').off();
                $(dlg_stamm).find('.remove').off();
                /**
                 * Handler neu setzen
                 * Item zufügen
                 */
                $(dlg_stamm).find('.add').click(function(event) {
                    var i = $('.stamm-inner').find('.stamm-item').length + 2;
                    console.log(i);
                    var item2add = $($template).clone();
                    item2add.show();
                    item2add.find('.labelData')[0].name = 'label-' + i;
                    item2add.find('.valueData')[0].name = 'value-' + i;
                    $('.stamm-inner').append(item2add);
                    item2add.find('.remove').click(function(event) {
                        $(event.currentTarget).closest('.stamm-item').remove();
                        $(dlg_stamm).find('.stamm-inner .stamm-item').each(function(i, el) {
                            $(el).find('.labelData')[0].name = 'label-' + i;
                            $(el).find('.valueData')[0].name = 'value-' + i;
                        });
                    });
                });
                /**
                 * Handler neu setzen
                 * Item entfernen
                 */
                $(dlg_stamm).find('.remove').click(function(event) {
                    $(event.currentTarget).closest('.stamm-item').remove();
                    $(dlg_stamm).find('.stamm-inner .stamm-item').each(function(i, el) {
                        $(el).find('.labelData')[0].name = 'label-' + i;
                        $(el).find('.valueData')[0].name = 'value-' + i;
                    });
                });
                $template.hide();
                if (!dlg_stamm.saveTemplateData) {
                    dlg_stamm.saveTemplateData = $(dlg_stamm).find('button.ok').click(function(event) {
                        var $data = $(dlg_stamm).find('.stamm-inner input');
                        var data = {};
                        $data.each(function(i, el) {
                            data[el.name] = el.value;
                        });
                        data['pegel'] = dlg_stamm.pegelName;
                        data['extra'] = dlg_stamm.extra;
                        data['update'] = 1;
                        data['warn1'] = $('#warn1').val();
                        data['warn2'] = $('#warn2').val();
                        data['acv'] = $('#stamm-acv').val();
                        $.ajax({
                            cache: false,
                            type: "POST",
                            url: url,
                            data: {
                                data: data
                            }
                        }).done(function(data) {
                            tools.toast('Speichern', 'Stammdaten gespeichert');
                            if ($('.edit-stammdaten>i').attr('data-callback')) {
                                var cb = $('.edit-stammdaten>i').attr('data-callback');
                                alert(cb);
                                eval(cb + "()");
                            }
                            //var $col1 = $($(el).parents('.col-xs-12').find('.container-fluid.block .row .entrys>div')[0]).clone();
                            //var $col2 = $($(el).parents('.col-xs-12').find('.container-fluid.block .row .entrys>div')[1]).clone();
                            //var $container = $(el).parents('.col-xs-12').find('.container-fluid.block .row');
                            ////TODO: Aktualisieren der Daten im editmode
                            //If ($col1.length > 0) {
                            //    $container.html('');
                            //    for (var n = 0; n < $data.length; n = n + 2) {
                            //        var dummy1 = $col1.clone();
                            //        dummy1.find('div').text($data[n].value);
                            //        var dummy2 = $col2.clone();
                            //        dummy2.find('div').text($data[n + 1].value);
                            //        $container.append(dummy1);
                            //        $container.append(dummy2);
                            //    }
                            ////}
                            dlg_stamm.dialog("close");
                            $('.stamm-inner').html('');
                        });
                    });
                }
            } else {
                var items = $(dlg_stamm).find('input');
                items.each(function(i, el) {
                    el.value = data[el.name];
                });
                if (!dlg_stamm.savePegelData) {
                    dlg_stamm.savePegelData = $(dlg_stamm).find('.ok').click(function(event) {
                        var $data = $(dlg_stamm).find('input');
                        var data = {};
                        $($data).each(function(i, el) {
                            data[el.name] = $(el).val();
                        });
                        $.ajax({
                            cache: false,
                            type: "POST",
                            url: "/Handler/HvD/PegelSave",
                            data: {
                                'data': data
                            }
                        }).done(function(data) {
                            // TODO
                            //console.debug(data);
                        });

                        dlg_stamm.dialog("close");
                    });
                }
            }
        });
        dlg_stamm.dialog({
            title: 'Stammdaten: ' + dlg_stamm.pegelName
        });
        dlg_stamm.dialog("open");
    }
    $(dlg_stamm).find('.cancel').click(function(event) {
        dlg_stamm.dialog("close");
        $('.stamm-inner').html('');
    });
}
window.setTimeout(init, 200);
